import { Box, Dialog, IconButton, Stack, Typography } from "@mui/material";
import { Close, MenuBookOutlined } from "@mui/icons-material";
import { typeColor } from "../../styles/commonStyles";
import ImageContainer from "../forms/noteForm/imageContainer.component";
import Map from "../map/map.component";
import UnderlineButton from "../buttons/underlineButton.component";
import { useNoteDetail } from "../../hook/fieldNotebook/useNoteDetail";
import { noteDetailDialogConfig } from "./config";
import { getDiseaseName } from "../../utils/fieldNotebookUtils";
import { useSelector } from "react-redux";

const InfoRow = ({ label, value }) => (
  <Stack direction="row" alignItems="flex-start" spacing={1}>
    <Typography fontSize="14px" color="grey">
      {label}:
    </Typography>
    <Typography fontSize="14px">{value}</Typography>
  </Stack>
);

const NoteDetailDialog = ({ open, onClose, note, onEdit }) => {
  const noteData = useNoteDetail(note);
  const diseaseList = useSelector((state) => state.diseases?.data?.data);

  if (!note || !noteData) return null;

  const {
    hasPhotos,
    hasPosition,
    formattedImages,
    fieldPolygon,
    fieldCenter,
    isDisease,
  } = noteData;

  const diseaseName = note?.disease
    ? getDiseaseName(note.disease?.name, diseaseList)
    : null;

  return (
    <Dialog
      open={open}
      aria-labelledby="note-detail-dialog"
      aria-describedby="detail note"
      sx={{
        "& .MuiDialog-paper": noteDetailDialogConfig.paper,
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        gap={2}
      >
        <Stack direction="row">
          <Box
            display="flex"
            flexDirection="row"
            gap={2}
            height="40px"
            width="90%"
            justifyContent="space-between"
            alignItems="start"
          >
            <Stack direction="row" spacing={2}>
              <Box sx={noteDetailDialogConfig.iconBox}>
                <MenuBookOutlined />
              </Box>
              <Stack direction="column">
                <Typography fontWeight="bold" fontSize="20px">
                  {note?.title}
                </Typography>
                <Typography
                  fontWeight="bold"
                  fontSize="14px"
                  color={typeColor[note?.note_type]}
                >
                  {isDisease ? "Segnalazione malattia" : "Nota"}
                </Typography>
              </Stack>
            </Stack>
            <UnderlineButton
              label="Modifica nota"
              color="grey"
              onClick={onEdit}
            />
          </Box>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <Close
              sx={{ width: "20px", height: "20px", color: "text.primary" }}
            />
          </IconButton>
        </Stack>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          height="100%"
          paddingX={"55px"}
          paddingY={"45px"}
        >
          <Box
            width="100%"
            height="100%"
            gap={1}
            display="flex"
            flexDirection="column"
          >
            <InfoRow label="Terreno" value={note.field.name} />
            {note?.disease && (
              <InfoRow label="Tipologia malattia" value={diseaseName} />
            )}
            <InfoRow label="Nota" value={note.description} />
            {hasPosition && (
              <Box sx={noteDetailDialogConfig.mapBox}>
                <Typography fontSize="14px">Posizione su mappa</Typography>
                <Map
                  zoomLevel={7}
                  fieldPosition={fieldCenter}
                  polygonCoordinates={fieldPolygon}
                  markerPosition={note?.position}
                  isMarkerMode
                  isMarkerReadOnly
                />
              </Box>
            )}
            {hasPhotos && (
              <Box mt={2}>
                <Typography fontSize="14px">Foto</Typography>
                <ImageContainer
                  images={formattedImages}
                  isMobile={false}
                  onRemove={null}
                />
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default NoteDetailDialog;
